import { render, staticRenderFns } from "./overdue-invoices-by-client-list.vue?vue&type=template&id=67a3a198&scoped=true"
import script from "./overdue-invoices-by-client-list.vue?vue&type=script&lang=js"
export * from "./overdue-invoices-by-client-list.vue?vue&type=script&lang=js"
import style0 from "./overdue-invoices-by-client-list.vue?vue&type=style&index=0&id=67a3a198&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a3a198",
  null
  
)

export default component.exports